import styles from './ApplicantManagementTable.sass'

export enum ColumnId {
  Checkbox = 'Checkbox',
  Applicant = 'Applicant',
  Type = 'Type',
  Location = 'Location',
  Experience = 'Experience',
  TotalWorkspaces = 'TotalWorkspaces',
  // WorkspaceApplications = 'WorkspaceApplications',
  // GlobalApplications = 'GlobalApplications',
  GlobalCapacity = 'GlobalCapacity',
  ContactOwner = 'ContactOwner',
  Status = 'Status',
  Action = 'Action',
}

export type SearchableApplicantSortField =
  | 'applicant_id'
  | 'location'
  | 'status'

export type ApplicantManagementColumnDetails = {
  id: ColumnId
  header: string
  align: 'left' | 'center' | 'right'
  select: boolean
  sortable: boolean
  styles: string
  field?: SearchableApplicantSortField
}

// TODO: If sortable is true, specify a field
export const ApplicantManagementTableColumns: ApplicantManagementColumnDetails[] =
  [
    {
      id: ColumnId.Checkbox,
      header: '',
      select: false,
      align: 'left',
      styles: styles.checkboxColumn,
      sortable: false,
    },
    {
      id: ColumnId.Applicant,
      header: 'Applicant',
      select: false,
      align: 'left',
      styles: styles.applicantColumn,
      sortable: false,
    },
    {
      id: ColumnId.Type,
      header: 'Type',
      select: false,
      align: 'left',
      styles: styles.proTypeColumn,
      sortable: false,
    },
    {
      id: ColumnId.Location,
      header: 'Location',
      select: false,
      align: 'left',
      styles: styles.locationColumn,
      sortable: false,
    },
    {
      id: ColumnId.Experience,
      header: 'Experience',
      select: false,
      align: 'center',
      styles: styles.experienceColumn,
      sortable: false,
    },
    {
      id: ColumnId.TotalWorkspaces,
      header: 'Total workspaces',
      select: false,
      align: 'center',
      styles: styles.totalWorkspacesColumn,
      sortable: false,
    },
    // {
    //   id: ColumnId.WorkspaceApplications,
    //   header: 'Workspace applications',
    //   select: false,
    //   align: 'center',
    //   styles: styles.workspaceApplicationsColumn,
    //   sortable: false,
    // },
    // {
    //   id: ColumnId.GlobalApplications,
    //   header: 'Global applications',
    //   select: false,
    //   align: 'right',
    //   styles: styles.globalApplicationsColumn,
    //   sortable: false,
    // },
    // {
    //   id: ColumnId.GlobalCapacity,
    //   header: 'Global capacity',
    //   select: false,
    //   align: 'center',
    //   styles: styles.globalCapacityColumn,
    //   sortable: false,
    // },
    {
      id: ColumnId.ContactOwner,
      header: 'Contact owner',
      select: false,
      align: 'left',
      styles: styles.contactOwnerColumn,
      sortable: false,
    },
    {
      id: ColumnId.Status,
      header: 'Status',
      select: false,
      align: 'center',
      styles: styles.statusColumn,
      sortable: false,
    },
    {
      id: ColumnId.Action,
      header: '',
      select: false,
      align: 'right',
      styles: styles.actionColumn,
      sortable: false,
    },
  ]
